// Barre stackée RAM/swap utilisée par DeviceDetail.

const Bar = ({ segments }) => (
  <div className="w-full h-[22px] rounded-md overflow-hidden flex bg-sidebar">
    {segments.map((s, i) => (
      <div
        key={i}
        title={s.title}
        className="h-full transition-[width] duration-500"
        style={{ width: `${s.pct}%`, background: s.color }}
      />
    ))}
  </div>
);

const Legend = ({ items }) => (
  <div className="flex flex-wrap gap-x-4 gap-y-1.5 mt-1.5 text-[11px]">
    {items.map((it, i) => (
      <div key={i} className="flex items-center gap-1.5">
        <div
          className="w-2.5 h-2.5 rounded-sm"
          style={{ background: it.color, border: it.border || 'none' }}
        />
        <span className="text-muted">{it.label}</span>
      </div>
    ))}
  </div>
);

const Header = ({ label, value }) => (
  <div className="flex justify-between items-baseline mb-1.5">
    <span className="text-xs text-fg-2 font-semibold">{label}</span>
    <span className="text-xs text-fg font-mono">{value}</span>
  </div>
);

export function MemoryBreakdown({ inv, fmtMB }) {
  const total = inv.totalMemoryMB || 1;
  const used = inv.usedMemoryMB || 0;
  const free = inv.freeMemoryMB || 0;
  const usedPct = (used / total) * 100;
  const freePct = (free / total) * 100;

  const swapTotal = inv.totalSwapMB || 0;
  const swapUsed = inv.usedSwapMB || 0;
  const swapFree = inv.freeSwapMB || 0;
  const swapUsedPct = swapTotal > 0 ? (swapUsed / swapTotal) * 100 : 0;

  return (
    <div>
      <div className="mb-3.5">
        <Header label="RAM physique" value={`${fmtMB(used)} utilisés / ${fmtMB(total)} total`} />
        <Bar
          segments={[
            {
              pct: usedPct,
              color: usedPct >= 90 ? '#ef4444' : usedPct >= 75 ? '#f59e0b' : '#3b82f6',
              title: `Utilisée : ${fmtMB(used)} (${usedPct.toFixed(1)}%)`,
            },
            {
              pct: freePct,
              color: '#1a2a3a',
              title: `Libre : ${fmtMB(free)} (${freePct.toFixed(1)}%)`,
            },
          ]}
        />
        <Legend
          items={[
            { color: '#3b82f6', label: `Utilisée — ${fmtMB(used)} (${usedPct.toFixed(1)}%)` },
            {
              color: '#1a2a3a',
              border: '1px solid #2a3a50',
              label: `Libre — ${fmtMB(free)} (${freePct.toFixed(1)}%)`,
            },
          ]}
        />
      </div>

      {swapTotal > 0 && (
        <div>
          <Header
            label="Swap / Fichier d'échange"
            value={`${fmtMB(swapUsed)} utilisés / ${fmtMB(swapTotal)} total`}
          />
          <Bar
            segments={[
              {
                pct: swapUsedPct,
                color: swapUsedPct >= 80 ? '#ef4444' : '#8b5cf6',
                title: `Swap utilisé : ${fmtMB(swapUsed)} (${swapUsedPct.toFixed(1)}%)`,
              },
              {
                pct: 100 - swapUsedPct,
                color: '#1a1535',
                title: `Swap libre : ${fmtMB(swapFree)}`,
              },
            ]}
          />
          <Legend
            items={[
              {
                color: '#8b5cf6',
                label: `Swap utilisé — ${fmtMB(swapUsed)} (${swapUsedPct.toFixed(1)}%)`,
              },
              {
                color: '#1a1535',
                border: '1px solid #2a2045',
                label: `Swap libre — ${fmtMB(swapFree)}`,
              },
            ]}
          />
        </div>
      )}
    </div>
  );
}
